'use strict';

require('../vendor');

require('intersection-observer');

require('lazysizes/plugins/object-fit/ls.object-fit');

require('lazysizes/plugins/parent-fit/ls.parent-fit');

require('lazysizes/plugins/rias/ls.rias');

require('lazysizes/plugins/bgset/ls.bgset');

require('lazysizes');

require('lazysizes/plugins/respimg/ls.respimg');

require('../utils/class-list-polyfill');

require('../utils/focus-ring');

require('../utils/svgforeverybody');

require('../../styles/theme.pcss');

var _functional = require('../utils/functional');

var _utils = require('../utils');

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _fadeIn = require('../components/fade-in');

var _fadeIn2 = _interopRequireDefault(_fadeIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.slate = window.slate || {};
window.theme = window.theme || {};
window.$ = _jquery2.default;
window.jQuery = _jquery2.default;
// window.ShopifyAPI = cart

document.addEventListener('DOMContentLoaded', function () {
  if ((0, _functional.getElement)('.js-FadeIn')) {
    new _fadeIn2.default((0, _functional.getElements)('.js-FadeIn'));
  }

  (0, _utils.externalLinks)();
  (0, _utils.wrapTables)({
    elements: (0, _functional.getElements)('.rte-RichText table')
  });
  (0, _utils.wrapIframes)({
    elements: (0, _functional.getElements)('.rte-RichText iframe')
  });

  (0, _functional.getElements)('[data-module]').forEach(function (el) {
    var name = el.getAttribute('data-module');
    var Module = require('../modules/' + name).default;
    new Module(el);
  });
});

(0, _jquery2.default)(function () {
  ajaxCart.init({
    formSelector: '[action="/cart/add"]',
    cartContainer: '#CartContainer',
    addToCartSelector: '[data-add-to-cart]',
    cartCountSelector: '[data-cart-count]',
    cartCostSelector: '#CartCost',
    moneyFormat: theme.moneyFormat
  });

  ajaxCart.load();
});

// History - return to previous page
window.goBack = function () {
  window.history.back();
};

/****
 * Setup CSS Grid & CSS Vars fallbacks
 ****/
var body = document.documentElement || document.body;
body.classList.add('util-JSEnabled');

if (!('grid' in body.style)) {
  require('../utils/css-grid-fallback');
  body.className += ' util-NoGrid';
}

function hasNativeCSSProperties() {
  var opacity = '0';
  var el = body;
  // Setup CSS properties.
  el.style.setProperty('--test-opacity', opacity);
  el.style.setProperty('opacity', 'var(--test-opacity)');
  // Feature detect then remove all set properties.
  var hasNativeCSSProperties = window.getComputedStyle(el).opacity === opacity;
  el.style.setProperty('--test-opacity', '');
  el.style.opacity = '';
  return hasNativeCSSProperties;
}

if (!hasNativeCSSProperties()) {
  require('../utils/vars-fallback');
  body.className += ' util-NoCssVars';
}